module.exports = __webpack_public_path__ + "static/media/step2.26f5b734.gif";